import { render, staticRenderFns } from "./IgnoreSonInvestigationModal.vue?vue&type=template&id=3f93f0e7&scoped=true"
import script from "./IgnoreSonInvestigationModal.vue?vue&type=script&lang=js"
export * from "./IgnoreSonInvestigationModal.vue?vue&type=script&lang=js"
import style0 from "./IgnoreSonInvestigationModal.vue?vue&type=style&index=0&id=3f93f0e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f93f0e7",
  null
  
)

export default component.exports